import handleProduct from './seoMeta/product'
import handleHome from './seoMeta/home'
import handleSearch from './seoMeta/search'
import handleCategory from './seoMeta/category'
import handleFaq from './seoMeta/faq'

const FALLBACK_IMAGE = 'https://cdn.daisomall.co.kr/file/CM/daisologo_1.91-1.png'

/**
 * seoMeta 미들웨어 - 라우터
 * 경로에 따라 적절한 핸들러를 호출하여 <head> SSR 메타데이터를 생성
 */
export default async function ({ store, route }) {
  if (process.client) { return }

  store.commit('seoMeta/clear')

  const path = route.path

  try {
    // 홈
    if (path === '/ds' || path === '/ds/') {
      handleHome({ store, route })
      return
    }

    // 검색결과
    if (path.includes('/ds/dst/SCR_DST_0015') && route.query.searchTerm) {
      handleSearch({ store, route })
      return
    }

    // 상품상세
    if (path.includes('/pd/pdr/SCR_PDR_0001') && route.query.pdNo) {
      await handleProduct({ store, route })
      return
    }

    // 카테고리
    if (path.includes('/ds/exhCtgr/') && route.params.lgCtgrNo) {
      await handleCategory({ store, route })
      return
    }

    // FAQ
    if (path.includes('/cs/csi/SCR_CSI_0001')) {
      await handleFaq({ store, route })
      return
    }

    // 기획전 상세 (기존 로직 유지)
    if (path.includes('/ds/spexhbt/')) {
      const canonicalUrl = `https://www.daisomall.co.kr${path}`
      store.commit('seoMeta/set', {
        title: '기획전 상세 - 다이소몰',
        description: '다이소몰 기획전',
        ogUrl: canonicalUrl,
        ogImage: FALLBACK_IMAGE,
        canonical: canonicalUrl
      })
      return
    }

    // 기획전 목록 (기존 로직 유지)
    if (path.match(/^\/ds\/exbt\/[^/]+$/)) {
      const canonicalUrl = `https://www.daisomall.co.kr${path}`
      store.commit('seoMeta/set', {
        title: '기획전 - 다이소몰',
        description: '다이소몰 기획전 모아보기',
        ogUrl: canonicalUrl,
        ogImage: FALLBACK_IMAGE,
        canonical: canonicalUrl
      })
      return
    }
  } catch (e) {
    console.error('[seoMeta middleware]', e.message)
  }
}
